<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-yearly-management-confirm-dialog"
        top="10vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        :close-on-click-modal="false"
        width="400px"
        @open="onOpen"
    >
        <template slot="title">
            <span>{{ purposeText }}</span>
        </template>
        <div class="container">
            <div class="description">
                <div v-if="descriptionText">
                    <h3>{{ descriptionText.title }}</h3>
                    <div style="margin-top: 20px;">{{ descriptionText.description }}</div>
                </div>
                <div v-else>
                    <el-form :model="form" :rules="rules" ref="form" label-position="top" v-loading="isLoading">
                        <el-form-item prop="reason" :label="purpose === 'unlock' ? '解除原因' : '取消原因'">
                            <el-input v-model="form.reason" type="textarea" :rows="3" placeholder="請輸入取消原因" />
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="button-container">
            <el-button class="cancel-btn" :isLoading="isLoading" @click="$emit('close')">取消</el-button>
            <el-button type="primary" :isLoading="isLoading" @click="onConfirm"> 確認{{ purposeText }} </el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        purpose: {
            type: String,
            default: null,
        },
        year: {
            type: Number,
            default: null,
        },
        id: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            form: { reason: '' },
            rules: { reason: [{ required: true, message: '請輸入原因', trigger: 'blur' }] },
        };
    },
    computed: {
        purposeText() {
            switch (this.purpose) {
            case 'lock':
                return '帳務鎖定';
            case 'unlock':
                return '解除帳務鎖定';
            case 'close':
                return '關帳';
            case 'reopen':
                return '取消關帳';
            default:
                return null;
            }
        },
        descriptionText() {
            switch (this.purpose) {
            case 'lock':
                return {
                    title: `確定要鎖定 ${this.year - 1911} 年度會計報表？`,
                    description: '禁止編輯該年度的傳票、新產生的傳票將不被列入計算。',
                };
            case 'close':
                return {
                    title: `確定要關帳 ${this.year - 1911} 年度？`,
                    description: '所有人員不可再針對關帳年度進行任何帳務變動。',
                };
            default:
                return null;
            }
        },
    },
    methods: {
        onOpen() {
            this.$nextTick(() => {
                if (this.purpose === 'unlock' || this.purpose === 'reopen') {
                    this.form = { reason: '' };
                    this.$refs.form.clearValidate();
                }
            });
        },
        async onBeforeClose() {
            this.$emit('close');
        },
        async onConfirm() {
            if (this.purpose === 'unlock' || this.purpose === 'reopen') {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        let url;
                        if (this.purpose === 'unlock') url = 'UnlockTask';
                        else url = 'UncloseTask';

                        try {
                            this.isLoading = true;

                            await this.$api({
                                url: `AnnualAccountingTask/${url}`,
                                method: 'POST',
                                data: {
                                    id: this.id,
                                    reason: this.form.reason,
                                },
                            });
                            this.$emit('close', true);
                        } catch (error) {
                            console.error('API Error:', error);
                        } finally {
                            this.isLoading = false;
                        }
                    }
                });
            } else {
                let url;
                let finishMsg = '';
                switch (this.purpose) {
                case 'lock':
                    url = 'LockTask';
                    finishMsg = `${this.year - 1911} 年已鎖定`;
                    break;
                case 'close':
                    url = 'CloseTask';
                    finishMsg = `${this.year - 1911} 年已關帳`;
                    break;
                default:
                    console.error('未知操作');
                    this.$emit('close');
                    return;
                }

                if (url) {
                    try {
                        this.isLoading = true;

                        await this.$api({
                            url: `AnnualAccountingTask/${url}`,
                            method: 'POST',
                            data: { id: this.id },
                        });
                        this.$message.success(finishMsg);
                        this.$emit('close', true);
                    } catch (error) {
                        console.error('API Error:', error);
                    } finally {
                        this.isLoading = false;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss">
.accounting-yearly-management-confirm-dialog {
    .container {
        padding: 30px 50px 0;
        min-height: 150px;
    }
    .button-container {
        display: flex;
        justify-content: center;
        padding: 20px 0 40px;
    }
    .description {
        font-size: 12pt;
    }
}
</style>
